/**
 * TOS / Privacy / Marketing legal copy constants.
 *
 * Real legal texts are tracked outside this feature and will replace the
 * placeholder URLs when ready. The CONSENT_VERSION is sent in the signup
 * payload and persisted in the ConsentRecord rows so we can later require
 * re-acceptance when the version bumps.
 *
 * Single source of truth for both the registration form (Phase 5) and the
 * API payload it produces — see Phase 1 plan, IMPL-P1-007.
 */
export const CONSENT_VERSION = '2026-04-30-draft';
export const TOS_URL = '#tos-tbd';
export const PRIVACY_URL = '#privacy-tbd';
